import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import mainAxios from "../redux/api/mainAxios";
import { UserData } from "../redux/actions/userAuthActions";

const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [favoriteLots, setFavoritesLots] = useState([]);
  const dispatch = useDispatch();

  const userIdString = localStorage.getItem("user");
  const userId = JSON.parse(userIdString);
  const id = userId.id;

  const token = localStorage.getItem("token");

  const { user } = useSelector((state) => state.userAuthReducer);

  useEffect(() => {
    if (user) {
      setFavorites(user.programmes_favoris || []);
      setFavoritesLots(user.lots_favoris || []);
    }
  }, [user]);

  const isProgramInFavorites = (programmeId) => {
    return favorites.some((program) => program.documentId === programmeId);
  };

  const isLotInFavorites = (programmeId) => {
    return favoriteLots.some((program) => program.documentId === programmeId);
  };

  const handleAddToFavorites = async (programmeId, collectionType) => {
    try {
      const isFavorite = isProgramInFavorites(programmeId);
      const isLotFavorite = isLotInFavorites(programmeId);

      // Optimistically update UI
      const updatedFavorites = isFavorite
        ? favorites.filter((program) => program.documentId !== programmeId)
        : [...favorites, { documentId: programmeId }];
      const updatedLotFavorites = isLotFavorite
        ? favoriteLots.filter((program) => program.documentId !== programmeId)
        : [...favoriteLots, { documentId: programmeId }];

      // Update local state immediately for responsive UI
      setFavorites(updatedFavorites);
      setFavoritesLots(updatedLotFavorites);

      // Make API request to toggle favorite
      await mainAxios.post(`api/user/toggleFavorite`, {
        documentId: programmeId,
        collectionType: collectionType,
      });

      // Refresh user data to update Redux store
      dispatch(UserData());

      // Use the appropriate flag based on collection type
      const isRemoved = collectionType === "Lot" ? isLotFavorite : isFavorite;

      toast.success(
        isRemoved
          ? `${collectionType} retiré des favoris.`
          : `${collectionType} ajouté aux favoris.`
      );
    } catch (error) {
      console.error("Error toggling program in favorites:", error);
      // Revert local state on error
      if (user) {
        setFavorites(user.programmes_favoris || []);
        setFavoritesLots(user.lots_favoris || []);
      }
      toast.error("Erreur lors de la mise à jour des favoris.");
    }
  };

  return {
    favorites,
    isProgramInFavorites,
    handleAddToFavorites,
    isLotInFavorites,
  };
};

export default useFavorites;
